import api from "@/lib/api";

const CHUNK = 5 * 1024 * 1024;

const randomId = () =>
  Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");

// Upload a blocchi: il file resta temporaneo e viene eliminato a fine import.
export async function uploadWorkbook(file, onProgress, companyId) {
  const uploadId = randomId();
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let last;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("total", String(total));
    fd.append("filename", file.name);
    if (companyId) fd.append("company_id", companyId);
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    const { data } = await api.post("/ea/imports/chunk", fd);
    last = data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return last.import;
}

export const PHASES = [
  { key: "upload", label: "Upload" },
  { key: "analysis", label: "Analisi workbook" },
  { key: "report", label: "Lettura Report" },
  { key: "consumption", label: "Lettura consumi" },
  { key: "pun", label: "Lettura PUN" },
  { key: "validation", label: "Validazione" },
  { key: "saving", label: "Salvataggio" },
  { key: "done", label: "Completato" },
];

export const MONTHS = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
export const monthList = (arr) => (arr && arr.length ? arr.map((m) => MONTHS[m - 1]).join(", ") : "—");
